// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_ListImageRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Row shape for a single product gallery image entry.
 *
 * Mirrors the `so_product_images` table columns selected by
 * `So_product_images_model::getByProductId()`, plus the Azure Blob URLs
 * (`so_product_image_url`, `so_product_image_thumbnail_url`) appended by
 * the controller via the `azure_image` helper after fetching from the
 * model.
 *
 * Used inside `Products_ListImagesResponse` (typed array) and inside
 * `Products_GetResponse` (typed array enrichment), so the per-row schema
 * has a single canonical shape across both consumers — required by the
 * `no-response-array-of-response` QA rule, which forbids reusing the
 * upload Response shape as a list item.
 */
import { registerContract } from './validate'

export interface Products_ListImageRow {
so_product_image_id: number
so_product_id: number
so_product_image_filename: string
so_product_image_url: string
so_product_image_thumbnail_url: string
so_product_image_sort_order: number
so_product_image_is_primary: boolean
so_product_image_alt_text?: string
}

registerContract('Products_ListImageRow', {
  so_product_image_id:            { type: 'number',  required: true },
  so_product_id:                  { type: 'number',  required: true },
  so_product_image_filename:      { type: 'string',  required: true },
  so_product_image_url:           { type: 'string',  required: true },
  so_product_image_thumbnail_url: { type: 'string',  required: true },
  so_product_image_sort_order:    { type: 'number',  required: true },
  so_product_image_is_primary:    { type: 'boolean', required: true },
  so_product_image_alt_text:      { type: 'string',  required: false },
})
